import React from 'react';
import LocationForm from './LocationForm';

export default function AddLocation() {
  return <LocationForm />;
}
